import { render, staticRenderFns } from "./TrialReadinessStatementStep.vue?vue&type=template&id=06986670"
import script from "./TrialReadinessStatementStep.vue?vue&type=script&lang=ts"
export * from "./TrialReadinessStatementStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports